// Copyright (c) 2024 Lenovo. All right reserved.
// Confidential and Restricted
import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "@/store"
import LoginVue from '../views/login/index.vue'
import {  getRequest } from '@/api/api';
Vue.use(VueRouter)

const Store = store;

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginVue
  },
];

// Can allow repeated jumps
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

const isLogin = async function(){
    const res = await getRequest("/system/user/getRoleEnum");
    if (res && res.code === 200) {
      return true;
      //this.$router.push('/login');
    } else {
      return false;
    }
}

const getToken = function (toRoute) {
  //let temToken = sessionStorage.getItem('token');
  //return sessionStorage.getItem("isGetToken") == "true" ? true : false;
  /*
  let temToken = window.getCookie('token');
  if(temToken) return temToken;
  temToken = toRoute.query ? toRoute.query.token : '';
  return temToken;
  */
  let temToken;
  if(window.isProduction())
  {
    temToken = localStorage.getItem("isGetToken") == "true" ? true : false;
  }
  else
  {
    temToken = window.getCookie('token');
  }
  
  if(temToken) return temToken;
  temToken = toRoute.query ? toRoute.query.token : '';
  return temToken;
}

router.beforeEach(async (to, from, next) => {
  
  const isLoggedIn = getToken(to);
  if(to.name === 'Login') {
  //  console.log("router:",localStorage.getItem("isGetToken"));
    if(localStorage.getItem("isGetToken") == "true") // if logined then redirect /monitorList
    {
      next({ path: '/monitorList' });
      return;
    }
    if(!!window.getCookie('token'))
    {
      next({ path: '/monitorList' });
      return;      
    }
    
    Store.commit('resetState');
    //sessionStorage.token = '';
    //window.removeCookie('token');
    //Vue.prototype.$showUpdatePassword(false);
  }
  if(!isLoggedIn && to.name !== 'Login') {
    next({ path: '/login' });
    //Vue.prototype.$showUpdatePassword(false);
  }
  
  /**
   * The current user has refreshed the page or actively changed their permissions, updating the page permissions
   */
  if(isLoggedIn && !Store.state.isHasRoutes) {
    
    await Store.dispatch('isHasLoginData');
    addRoutes();
    next({ ...to });
    //Vue.prototype.$showUpdatePassword(false);
  }
  Store.commit('updateCurPagePath', to.path);
  /**
   * Determine if the current redirect page path is not in the current route. If it is not in the current route, reset it to the route where the current role exists
   */
  if(!Store.getters.menuRoutes[to.path.split('?')[0]] && !routes.map(i => i.path).includes(to.path)) {
    next(Store.getters.curRoleUserPath);
  }
  /**
   * Determine whether to refresh, if yes, replace according to the route
   */
  if(Store.state.refreshFlag) {
    Store.commit('updateRefreshFlag', false);
    next({ ...to, replace: true });
  } else {
    next();
  }
});

/**
 * Add Route
 */
const addRoutes = function () {
  if(Store.state.menuArr.length <= 0) return;
  let temRoutesObj = Store.getters.menuRoutes || {};
  for (const key in temRoutesObj) {
    if (temRoutesObj[key]) {
      router.addRoute({
        path: key,
        component: () => import(`@/views/${temRoutesObj[key].component}/index.vue`)
      })
    }
  }
  Store.commit('updateIsHasRoutes', true);
}

export default router
